import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getErrorResponseMessage } from '~/utils/getErrorResponseMessage';
import { actions } from '.';
import * as DeliveryPatternService from '../../_core/deliveryPattern/service';
import { alertRequest } from '../../alert/actions';
import { actions as actionsList } from '../deliveryPattern-list';
import { actions as actionsLoading } from '../loading';
import { DeliveryPatternCreateAction, Types } from './duck';

export function* createSaga(action: PayloadAction<DeliveryPatternCreateAction>): any {
  try {
    yield put(
      actionsLoading.setLoading({
        status: 'fetching',
      }),
    );
    yield call(DeliveryPatternService.create, action.payload);
    yield put(
      actionsLoading.setLoading({
        status: 'idle',
      }),
    );
    yield put(alertRequest('Alteração realizada com Sucesso', 'success'));
    yield put(actionsList.setSubmitForm(true));
    yield put(actions.setCloseModal(true));
  } catch (err: any) {
    yield put(
      actionsLoading.setLoading({
        status: 'idle',
      }),
    );
    yield put(alertRequest(getErrorResponseMessage(err), 'error'));
  }
}

export default [takeLatest(Types.CREATE, createSaga)];
